<template>
  <div
    class="ordering-counterparty ordering-page__wrapper"
    :class="{
      'ordering-counterparty--active': active,
      'ordering-counterparty--error': error
    }"
  >
    <OrderingCounterpartyRadio
      @change="$emit('change', form)"
      :checked="active"
    >
      {{ $t("services.ordering.counterparty.choose") }}
    </OrderingCounterpartyRadio>
    <div class="form__col form__col-3">
      <InputLabel class="form__input" error-position-static>
        <template #label>
          {{ $t("services.ordering.counterparty.name") }}
          <span class="form__required">*</span>
        </template>
        <input v-model="form.counterparty_name.value" />
        <template slot="error" v-if="form.counterparty_name.error">
          {{ form.counterparty_name.error }}
        </template>
      </InputLabel>
      <InputLabel class="form__input" error-position-static>
        <template #label>
          {{ $t("services.ordering.counterparty.inn") }}
          <span v-if="locale === 'ru'" class="form__required">*</span>
        </template>
        <input
          :placeholder="placeholderEn"
          v-model="form.counterparty_inn.value"
        />
        <template slot="error" v-if="form.counterparty_inn.error">
          {{ form.counterparty_inn.error }}
        </template>
      </InputLabel>
      <InputLabel class="form__input" error-position-static>
        <template #label>
          {{ $t("services.ordering.counterparty.kpp") }}
        </template>
        <input
          :placeholder="placeholderEn"
          v-model="form.counterparty_kpp.value"
        />
        <template slot="error" v-if="form.counterparty_kpp.error">
          {{ form.counterparty_kpp.error }}
        </template>
      </InputLabel>
    </div>
    <div
      class="ordering-counterparty-hiding"
      :class="{ 'ordering-counterparty-show': showFull }"
    >
      <div class="form__col form__col-2">
        <InputLabel class="form__input" error-position-static>
          <template #label>
            {{ $t("services.ordering.counterparty.legalAddress") }}
            <span class="form__required">*</span>
          </template>
          <input v-model="form.counterparty_legal_address.value" />
          <template slot="error" v-if="form.counterparty_legal_address.error">
            {{ form.counterparty_legal_address.error }}
          </template>
        </InputLabel>
        <InputLabel class="form__input" error-position-static>
          <template #label>
            {{ $t("services.ordering.counterparty.address") }}
            <span v-if="locale === 'ru'" class="form__required">*</span>
          </template>
          <input v-model="form.counterparty_address.value" />
          <template slot="error" v-if="form.counterparty_address.error">
            {{ form.counterparty_address.error }}
          </template>
        </InputLabel>
      </div>
      <div class="form__col form__col-2">
        <input-label class="form__input">
          <template #label>
            {{ $t("services.ordering.counterparty.bank") }}
            <span class="form__required">*</span>
          </template>
          <search-field
            v-model="form.bank.value"
            :autocomplete="isShowSearchList"
            :autocomplete-list="banks"
            is-default-label
            @autocompleteClick="chooseBank"
            @focus="isShowSearchList = true"
            v-click-outside="hideSearchList"
          />
        </input-label>

        <InputLabel class="form__input" error-position-static>
          <template slot="label">
            {{ $t("services.ordering.counterparty.bik") }}
            <span v-if="locale === 'ru'" class="form__required">*</span>
          </template>
          <the-mask
            :mask="'B'.repeat(15)"
            :tokens="inputMaskFilter"
            type="text"
            :placeholder="placeholderEn"
            v-model="form.counterparty_code.value"
          />
          <template slot="error" v-if="form.counterparty_code.error">
            {{ form.counterparty_code.error }}
          </template>
        </InputLabel>
      </div>
      <div class="form__col form__col-2">
        <InputLabel class="form__input" error-position-static>
          <template #label>
            {{ $t("services.ordering.counterparty.bankAccount") }}
            <span class="form__required">*</span>
          </template>
          <the-mask
            :mask="'B'.repeat(30)"
            :tokens="inputMaskFilter"
            type="text"
            v-model="form.bank_account.value"
          />
          <template slot="error" v-if="form.bank_account.error">
            {{ form.bank_account.error }}
          </template>
        </InputLabel>
        <InputLabel class="form__input" error-position-static>
          <template #label>
            {{ $t("services.ordering.counterparty.corAccount") }}
          </template>
          <input
            v-model="form.correspondent_account.value"
            v-mask="'#'.repeat(30)"
          />
          <template slot="error" v-if="form.correspondent_account.error">
            {{ form.correspondent_account.error }}
          </template>
        </InputLabel>
      </div>
    </div>
    <span @click="showFull = !showFull" class="ordering-counterparty-btn">
      {{
        showFull
          ? $t("services.ordering.counterparty.showLess")
          : $t("services.ordering.counterparty.showFull")
      }}
    </span>
  </div>
</template>

<script>
import { InputLabel, SearchField } from "@v2/shared/ui/components";
import OrderingCounterpartyRadio from "@/components/Custom/OrderingCounterpartyRadio.vue";
import { i18n } from "@v2/shared/config";
import moment from "moment/moment";
moment.locale(i18n.locale);
export default {
  name: "OrderingCounterpartyComponent",
  components: { SearchField, OrderingCounterpartyRadio, InputLabel },
  props: {
    data: Object,
    index: Number,
    active: Boolean,
    error: String
  },
  data() {
    return {
      isActive: this.$props.active,
      showFull: false,
      isShowSearchList: false,
      inputMaskFilter: {
        B: {
          pattern: /[0-9a-zA-Z]/
        }
      },
      form: {
        counterparty_name: {
          value: null,
          error: null
        },
        counterparty_inn: {
          value: null,
          error: null
        },
        counterparty_kpp: {
          value: null,
          error: null
        },
        counterparty_legal_address: {
          value: null,
          error: null
        },
        counterparty_address: {
          value: null,
          error: null
        },
        counterparty_code: {
          value: null,
          error: null
        },
        bank: {
          id: null,
          value: null,
          error: null
        },
        bank_account: {
          value: null,
          error: null
        },
        correspondent_account: {
          value: null,
          error: null
        }
      },
      banks: [],
      debounce: null
    };
  },
  computed: {
    locale() {
      return i18n.locale;
    },
    placeholderEn() {
      return this.locale === "en" ? "Only for Russian companies" : "";
    }
  },
  mounted() {
    this.form.counterparty_name.value = this.data.name;
    this.form.counterparty_inn.value = this.data.inn;
    this.form.counterparty_kpp.value = this.data.kpp;
    this.form.counterparty_legal_address.value = this.data.legal_address;
    this.form.counterparty_address.value = this.data.address;
    this.banks =
      this.data?.contracts
        ?.filter(contract => contract.bank)
        .reduce(
          (result, contract) => [
            ...result,
            ...[{ bank_account: contract.bank_account, ...contract.bank }]
          ],
          []
        ) || [];
    this.banks = this.banks.reduce((acc, current) => {
      if (acc.findIndex(obj => obj.id === current.id) === -1) {
        acc.push(current);
      }
      return acc;
    }, []);
    if (this.banks.length === 1) {
      this.form.bank.value = this.banks[0].name;
      this.form.counterparty_code.value = this.banks[0].code;
      this.form.correspondent_account.value = this.banks[0].correspondent_account;
      this.form.bank_account.value = this.banks[0].bank_account;
    }

    // по умолчанию выбран первый контрагент
    if (this.index === 0) {
      this.$emit("change", this.form);
    }
  },
  watch: {
    form: {
      handler() {
        clearTimeout(this.debounce);
        this.debounce = setTimeout(() => {
          this.$emit("input", this.form);
        }, 1000);
      },
      deep: true
    }
  },
  methods: {
    chooseBank(item) {
      this.hideSearchList();
      this.form.bank.value = item.name;
      this.form.counterparty_code.value = item.code;
      this.form.correspondent_account.value = item.correspondent_account;
      this.form.bank_account.value = item.bank_account;
    },
    hideSearchList() {
      this.isShowSearchList = false;
    }
  }
};
</script>

<style lang="scss">
.ordering-counterparty {
  border-radius: 2px;
  border: 2px solid transparent;
  transition: border-color var(--transition, 0.2s);

  &--active {
    border-color: var(--main-dark, #005197);
  }

  &--error {
    border-color: var(--red, #ea5330);
  }

  &-btn {
    display: none;
    margin-top: 20px;
    color: var(--main, #009ee3);
    font-size: 0.75rem;
    font-weight: 400;
    line-height: 18px; /* 150% */
    border-bottom: 1px solid var(--main, #009ee3);
    width: fit-content;
    cursor: pointer;

    @media (max-width: 640px) {
      display: flex;
    }
  }

  &-hiding {
    @media (max-width: 640px) {
      display: none;
    }
  }

  &-show {
    display: grid;
  }

  & .ordering-page__wrapper {
    margin-top: 20px;
  }
}
</style>
